import React from 'react';
import { formatarMoeda } from '../../utils/formatadores';
import LinhaContaBancaria from './LinhaContaBancaria';

const TabelaContasBancarias = ({ dadosContaBancaria, onTotalContasClick, onVencidasClick, onProximasClick }) => {
  return (
    <div className="rounded-lg border border-[color:var(--border)] overflow-hidden">
      {/* Desktop: tabela */}
      <div className="hidden sm:block overflow-x-auto">
        <table className="min-w-full divide-y divide-[color:var(--border)]">
        <thead className="bg-[color:var(--surface-muted)]">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider">
              Conta Bancária
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider">
              Total Contas
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider">
              Valor Total
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider">
              Valor Pago
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider">
              Valor Aberto
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider">
              Vencidas
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider">
              Próximas
            </th>
          </tr>
        </thead>
        <tbody className="bg-[color:var(--surface)] divide-y divide-[color:var(--border)]">
          {dadosContaBancaria.map((conta, index) => (
            <LinhaContaBancaria
              key={conta.nome || `conta-${index}`}
              conta={conta}
              onTotalContasClick={onTotalContasClick}
              onVencidasClick={onVencidasClick}
              onProximasClick={onProximasClick}
            />
          ))}
        </tbody>
      </table>
      </div>

      {/* Mobile: lista compacta */}
      <div className="sm:hidden divide-y divide-[color:var(--border)]">
        {dadosContaBancaria.map((conta, index) => (
          <button
            key={conta.nome || `conta-mobile-${index}`}
            onClick={() => onTotalContasClick && onTotalContasClick(conta)}
            className="w-full text-left px-4 py-3 hover:bg-[color:var(--surface-muted)] transition-colors"
          >
            <div className="text-sm font-semibold text-[color:var(--text-primary)] truncate" title={conta.nome}>
              {conta.nome}
            </div>
            <div className="mt-1 flex items-center justify-between text-xs text-[color:var(--text-muted)]">
              <span>{conta.totalContas} contas</span>
              <span className="font-medium text-[color:var(--text-primary)]">
                {formatarMoeda(conta.valorTotal)}
              </span>
            </div>
            <div className="mt-1 text-xs text-[color:var(--text-muted)]">
              {conta.fornecedoresUnicos} fornecedor{conta.fornecedoresUnicos !== 1 ? 'es' : ''}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabelaContasBancarias;




